// (c) chaehongee. Confidential and proprietary.

import { useEffect, useState } from 'react'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Lock, Eye } from 'lucide-react'
import { useReadOnlyMode } from '../../store/hooks/useReadOnlyMode'
import { useAuth } from '../../store/hooks/useAuth'
import styles from './ReadOnlyBanner.module.css'

export function ReadOnlyBanner(): ReactElement | null {
    const readOnly = useReadOnlyMode()
    const { user } = useAuth()
    const { t } = useTranslation('auth')
    const [isShaking, setIsShaking] = useState(false)

    useEffect(() => {
        if (!readOnly) return

        const handleShake = () => {
            setIsShaking(true)
            // Remove shake class after animation completes
            setTimeout(() => {
                setIsShaking(false)
            }, 600) // Match animation duration
        }

        window.addEventListener('readonly:shake', handleShake)
        return () => {
            window.removeEventListener('readonly:shake', handleShake)
        }
    }, [readOnly])

    if (!readOnly) return null

    const handleSignInClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        const returnUrl = window.location.pathname
        window.dispatchEvent(new CustomEvent('show:login', {
            detail: { returnUrl }
        }))
    }

    return (
        <div className={`${styles.banner} ${isShaking ? styles.shake : ''}`}>
            {user ? (
                <span><Lock className={styles.inlineIcon} aria-hidden="true" /> {t('noEditAccess')} <br /> {t('askOwnerToShare')}</span>
            ) : (
                <>
                    <Eye className={styles.inlineIcon} aria-hidden="true" /> {t('viewingReadOnly')}{' '}
                    <a
                        href="#"
                        onClick={handleSignInClick}
                        className={styles.signInLink}
                    >
                        {t('signInToChatAndEdit')}
                    </a>
                </>
            )
            }
        </div >
    )
}
